import { render, staticRenderFns } from "./VerificationsDashboard.vue?vue&type=template&id=243245fe&scoped=true"
import script from "./VerificationsDashboard.vue?vue&type=script&lang=ts"
export * from "./VerificationsDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243245fe",
  null
  
)

export default component.exports